import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";
import React from "react";

interface ColorLinkProps {
  color: string | null | undefined;
  label: string | null | undefined;
  style?: SxProps;
}

const ColorLink = (props: ColorLinkProps) => {
  if (!props.label || !props.color) return null;
  return (
    <Box
      sx={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        ...props.style,
      }}
      onClick={() => window.open(`/analytics/estimator?color=${props.color}`)}
    >
      {props.label}
      <OpenInNewIcon fontSize="small" />
    </Box>
  );
};

export default ColorLink;
